import { gsap } from 'gsap';
import Dropin from '../components/Dropin';

export default class SocialDropdowns {
	constructor() {
		document.addEventListener('bless', ({ detail }) => {
			this.container = detail.next.container;
			this.init(detail.next.container);
		});

		this.openedDropdown = null;
	}

	init() {
		if (this.dropin) {
			this.dropin.destroy();
		}

		if (!this.container) {
			this.container = document.querySelector('body');
		}

		this.dropinElm = this.container.querySelector('.c-social-dropin');
		this.dropin = new Dropin(this.dropinElm, this.container, this);

		this.socialDropdowns = this.container.querySelectorAll('.c-social-dropdown');
		document.addEventListener('click', (e) => {
			if (e.target.closest('[data-socialdropdown]')) {
				this.open(e.target.closest('[data-socialdropdown]'));
			}
			if (!e.target.closest('[data-socialdropdown]')) {
				if (this.openedDropdown) {
					this.close();
				}
			}
			if (e.target.closest('[data-close-socialdropdown]')) {
				if (this.openedDropdown) {
					this.close();
				}
			}
		});
	}

	open(dropdown, index) {
		this.socialDropdowns.forEach((dropdown) => {
			this.close(dropdown);
		});

		this.openedDropdown = dropdown;

		dropdown.classList.add('c-social-dropdown--open');

		let dropdownHeight = dropdown.querySelector('.c-social-dropdown__menu').offsetHeight;
		let dropdownMenuWrapper = dropdown.querySelector('.c-social-dropdown__menu-wrapper');

		let duration = 0.6;
		if (dropdown.classList.contains('c-social-dropdown--event')) {
			duration = 0;
		}

		gsap.to(dropdownMenuWrapper, {
			height: dropdownHeight,
			duration: duration,
			ease: 'expo.out',
		});
	}

	close() {
		if (!this.openedDropdown) {
			return;
		}

		this.openedDropdown.classList.remove('c-social-dropdown--open');
		let dropdownMenuWrapper = this.openedDropdown.querySelector('.c-social-dropdown__menu-wrapper');
		let originalHeight = getComputedStyle(this.openedDropdown).getPropertyValue('--social-dropdown-height');

		let duration = 0.6;
		if (this.openedDropdown.classList.contains('c-social-dropdown--event')) {
			duration = 0;
		}

		gsap.to(dropdownMenuWrapper, {
			height: originalHeight,
			duration: duration,
			ease: 'expo.out',
		});

		this.openedDropdown = null;
	}

	show() {
		document.body.classList.add('body--social-dropdowns-dropin');
	}

	hide() {
		document.body.classList.remove('body--social-dropdowns-dropin');
		this.close();
	}
}
